import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/theme-overrides.css";
import ArgonDashboard from "./argon-dashboard";
import { applyThemeColors } from "./utils/themeColors";

applyThemeColors();

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.config.globalProperties.$isDemo = process.env.VUE_APP_IS_DEMO || 0;
router.isReady().then(() => {
  store.commit("applyRouteLayout", router.currentRoute.value);
  store.commit("applySidenavBreakpoint");
});

appInstance.mount("#app");

window.addEventListener("resize", () => store.commit("applySidenavBreakpoint"));
